export default {
  common: {
    nav: {
      home: "ہوم",
      find_offer_help: "مدد تلاش کریں / پیش کریں",
      celebrate: "زندگی کا جشن",
      family_tree: "خاندانی شجرہ",
      events: "تقریبات",
      civic_reports: "شہری رپورٹس",
      neighborhood_pulse: "محلے کی دھڑکن",
      weather: "موسم",
      nature: "قدرت",
      marketplace: "بازار",
      news: "خبریں",
      causes: "مقاصد",
      more: "مزید",
    },
    header: { sign_in: "سائن ان", join: "Social Pulse میں شامل ہوں", language: "زبان", search: "تلاش" },
    tagline: "کمیونٹیز کو جوڑنا · زندگیوں کو بااختیار بنانا · سماجی سرمایہ کی تعمیر",
    locality: { viewing_from: "آپ دیکھ رہے ہیں", change: "تبدیل کریں", set_your_location: "اپنا مقام سیٹ کریں" },
    news: { title: "آپ کی روزانہ بریفنگ۔", play_briefing: "روزانہ بریفنگ چلائیں", listen: "سنیں", translate: "ترجمہ کریں" },
  },
};
